var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('base-navigation-tabs',{attrs:{"items":_vm.paths}}),_c('v-card',{staticClass:"mt-2",attrs:{"min-height":"80vh"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }